<template>
  <div
    v-click-outside="clickOutsideSlideLeft"
    class="flex flex-col flex-none w-56 border-r border-base-30 aha-side-left bg-base-0"

    :class="{'show-grid-slide': showingSlideGrid, 'min-w-max': !showingSlideGrid}"
    @click="clickSlideLeft"
  >
    <div v-if="!isBackstage" class="h-16 aha-slide-left-top">
      <div class="relative flex w-56 px-2 pt-2 pb-3">
        <div v-if="isDisableEditPresentation" class="overlay-disable-top-side-left"></div>
        <aha-button
          class="new-slide-context-cta"
          variant="primary"
          :disabled="isSelectMode"
          @click="addNewSlide()"
        >
          <font-awesome-icon icon="plus" class="mr-1 text-xs" />
          New Slide
        </aha-button>
        <aha-button
          variant="base"
          class="ml-2"
          :disabled="isSelectMode"
          icon-name="import"
          :submitting="isImportingSlides"
          @click="importPpt()"
        >
          <aha-spinner v-if="isImportingSlides" class="mr-1" />
          Import
        </aha-button>
      </div>
      <div
        v-if="showingSlideGrid"
        class="aha-slide-grid-action"
        :class="{'not-allow': isSelectMode}"
      >
        <div class="relative flex items-center justify-center flex-1" @mouseup.stop>
          <div v-if="isDisableEditPresentation" class="overlay-disable-grid-action"></div>
          <ul>
            <li class="relative">
              <a
                :disabled="isSelectMode"
                @click="duplicateSelectedSlides()"
              >
                <aha-icon
                  name="duplicate"
                  class="mr-2 text-primary-90"
                  width="18"
                  height="18"
                  viewBox="0 0 20 20"
                />
                <span class="text-base-90 hover:text-primary-90 text-md14-h18">Duplicate</span>
              </a>
            </li>
            <li
              v-tooltip="{content: isGuestUser?'This feature is disabled in Demo Mode':false}"
              class="relative"
              :class="{'disabled': isGuestUser}"
            >
              <a
                :disabled="isSelectMode || isGuestUser"
                @click="copySlidesTo()"
              >
                <font-awesome-icon icon="file-import" class="mr-2 text-primary-90" />
                <span class="text-base-90 hover:text-primary-90 text-md14-h18">Copy to...</span>
              </a>
            </li>
            <li class="relative">
              <a
                :disabled="isSelectMode"
                class="relative"
              >
                <font-awesome-icon icon="exchange-alt" class="mr-2 text-primary-90" />
                <span class="text-base-90 text-md14-h18">Rearrange…</span>

                <select
                  v-model="selectedOrder"
                  class="slide-rearrange-options"
                  @change="rearrangeSelectedSlides()"
                >
                  <option disabled>
                    Move slide to position:
                  </option>
                  <option
                    v-for="(option,slideIndex) in $store.state.presentation.slides"
                    :key="slideIndex"
                    :value="slideIndex"
                  >
                    {{ slideIndex + 1 }}
                  </option>
                </select>
              </a>
            </li>
            <li class="relative" :class="{'disabled': isResetResultsButtonDisabled}">
              <a
                class="reset-results-button"
                @click="isResetResultsButtonDisabled ? false : clearSelectedSlides()"
              >
                <aha-icon name="reset" class="mr-2 text-primary-90" />
                <span
                  class="text-base-90 hover:text-primary-90 text-md14-h18"
                >Reset results</span>
              </a>
            </li>
            <li
              class="relative aha-slide-delete-button"
              :class="{'disabled': isSelectMode || isSelectAll}"
            >
              <a
                @click="deleteSelectedSlides()"
              >
                <font-awesome-icon icon="trash-alt" class="mr-2 text-red-50" />
                <span class="text-base-90 text-md14-h18">Delete</span>
              </a>
            </li>
            <li class="pl-6 border-l border-base-60" @click="toggleSelectMode()">
              <aha-button
                v-if="!isSelectMode"
                variant="base"
                class="relative -top-0.5 w-18"
              >
                Select...
              </aha-button>
              <aha-button
                v-else
                variant="primary"
                class="relative -top-0.5 w-18"
              >
                Done
              </aha-button>
            </li>
          </ul>
        </div>
        <div class="aha-slide-grid-close" @click="closeSlideGrid">
          <font-awesome-icon
            icon="times"
            class="ml-2.5 cursor-pointer font-bold text-base-60 hover:text-primary-90"
          />
        </div>
      </div>
    </div>
    <div
      ref="leftScrollBar"
      class="flex-grow overflow-y-auto"
    >
      <TakeOverToolbar class="take-over" />
      <draggable
        v-bind="dragOptions"
        ref="drag-list-wrapper"
        v-model="$store.state.presentation.slides"
        class="pb-2 list-group"
        :sort="!isDisableEditPresentation && !isBackstage"
        :bus="bus"
        :class="{
          'list-group-grid': showingSlideGrid,
          'select-mode': isSelectMode,
        }"
        tag="ul"
        @start="onDragStart"
        @end="onDragEnd"
        @change="handleDragAndDropSlide"
        @select="selectToDrag"
        @deselect="deselectToDrag"
      >
        <li
          v-for="(item, index) in $store.state.presentation.slides"
          :id="'slide-' + item.id"
          :key="item.id + '-' + item.order"
          class="list-group-item"
          :data-index="index"
          :class="{
            'active-slide': getActiveSlide(item),
            'icon-inside-black': item.textColour == '#ffffff',
            'has-icon-inside': item.typeObj && item.typeObj.iconInside,
            'select-slide': isSlideSelected(item),
          }"
        >
          <div
            :id="`slide-item-${item.id}`"
            :ref="`slide-index-${index}`"
            class="aha-slide-item"
            :class="item.type"
          >
            <div class="aha-slide-order">
              {{ index + 1 }}
            </div>
            <div
              v-if="!isDisableEditPresentation && !isBackstage"
              :id="`slide-kebab-${index}`"
              class="aha-slide-setting"
              @click.stop="openSettingSlide(index, item)"
            >
              <font-awesome-icon
                icon="ellipsis-v"
                class="aha-slide-setting-icon"
              />
            </div>
            <span
              v-if="item.notes"
              v-tooltip="{content: 'This slide has a note'}"
              class="aha-slide-has-note group"
              @click="focusNoteAndMakeSlideActive(item)"
            >
              <aha-icon
                class="inline group-hover:hidden"
                name="note-side-left"
                width="20"
                viewBox="0 0 25 24"
              />
              <aha-icon
                class="hidden group-hover:inline"
                name="note-side-left-fill"
                width="20"
                viewBox="0 0 25 24"
              />
            </span>

            <div
              class="aha-slide-content"
              :class="{
                'is-content-slide': item.type === 'freestyle'
              }"
              :style="{ 'background-color': item.baseColour, 'color': item.textColour }"
              @contextmenu.prevent="openSettingSlide(index, item, $event)"
            >
              <div class="h-full" @click="makeSlideActive(item)">
                <div
                  v-if="item.backgroundImage || item.backgroundCache"
                  class="aha-slide-bg-image"
                  :style="{
                    'opacity': item.visibility / 100,
                    'background-image': 'url(' + backgroundImage(item) + ')',
                  }"
                  :class="getSlideBgSize(item.backgroundSize)"
                />

                <div
                  v-if="(item.image && item.type == 'image'
                    && item.imageType == 'background')
                    || (item.image && (item.type == 'document' || item.type === 'freestyle'))"
                  class="aha-slide-bg-image"
                  :style="{ 'background-image': 'url(' + item.image.thumbnail + ')' }"
                  :class="getSlideBgSize(item.backgroundSize)"
                />

                <SlideTypeIcon
                  v-if="item.type !== 'freestyle'"
                  :slide-type="item.type"
                  :child-type="item.slideType"
                  :leftSide="true"
                  :textColour="item.textColour"
                  :class="{
                    'aha-slide-thumbnail-wrapper':
                      ((item.imageType == 'background' && item.type === 'image')
                        || item.type == 'document'
                      ) && item.image,
                    'dark': item.textColour == '#313131'}"
                />
                <FreestyleThumbnailPreview
                  v-if="item.type === 'freestyle'"
                  :slide="item"
                  :location="'preview'"
                />
                <div
                  class="aha-slide-title"
                  :class="{
                    'aha-slide-title-bg':
                      (item.imageType == 'background'
                        && item.type =='image'
                        && item.image && item.title
                        && item.title !== ' ')
                      || (item.type =='document'
                        && item.image
                        && item.title
                        && item.title !== ' '
                      ),
                    'dark': item.textColour == '#313131',
                    'opacity-0': item.type === 'freestyle'}"
                >
                  {{ item.title }}
                </div>
                <font-awesome-icon
                  v-if="item.notCheckCorrectAnswer"
                  v-tooltip="noCorrectAnswerTooltip"
                  icon="info-circle"
                  class="absolute text-lg text-yellow-100 -top-2 -right-2 z-5 aha-slide_infoicon"
                />
              </div>
              <div class="slide-drag" />
            </div>
          </div>
        </li>
        <li v-if="!isBackstage" class="create-context">
          <div class="aha-slide-item create-context-item">
            <div
              class="aha-slide-content"
              :class="{
                'pointer-events-none overlay-disable-grid-action': isDisableEditPresentation
              }"
            >
              <div
                class="flex items-center justify-center h-full new-slide-context-cta btn-cta"
                v-tooltip="'New slide'"
                @click.prevent="addNewSlide('Click on Side Left CTA', -1)"
              >
                <font-awesome-icon
                  icon="plus"
                  class="text-base text-base-80"
                />
              </div>
            </div>
          </div>
        </li>
      </draggable>
    </div>
    <div
      v-if="!isBackstage"
      class="aha-side-left-bottom"
      @mouseup.stop
    >
      <div
        class="aha-button-grid-view"
        title="Switch to Grid View"
      >
        <span v-if="!showingSlideGrid" @click="openSlideGrid">
          <font-awesome-icon icon="th-large" class="mr-2.5 text-lg font-bold text-primary-90" />
          Grid View
        </span>

        <span
          v-if="showingSlideGrid"
          class="text-base-90 hover:text-primary-90 close-gridview"
          @click="closeSlideGrid"
        >
          <font-awesome-icon icon="times" class="mr-2.5 text-md text-base-60 icon-close" />
          Close
        </span>
      </div>
      <div class="flex-1" />
      <div
        v-if="selectedSlideIds.length && selectedSlideIds.length > 1 && showingSlideGrid"
        class="flex px-6 align-middle text-base-90"
      >
        {{ selectedSlideIds.length }} Selected slides
        <span @click="deselectAllSlides()">
          <font-awesome-icon
            icon="times"
            class="ml-2.5 text-md text-base-60 icon-close cursor-pointer hover:text-primary-90"
          />
        </span>
      </div>
    </div>

    <ModalDeleteSlide
      v-if="showModalSlideDelete"
      :slides="modalData.slides"
      :title="modalData.title"
      :content="modalData.content"
      @hide="handleCloseModalDeleteSlide()"
      @deselectAllSlides="deselectAllSlides"
      @makeSlideActive="makeSlideActive"
    />

    <modal-clear-data-slide
      v-if="showModalClearDataSlide"
      :selectedSlides="gridViewSelectedSlides"
      @hide="handleCloseModalClearDataSlide()"
      @makeSlideActive="makeSlideActive"
    />

    <modal-import
      v-if="$store.state.openImportModal"
      :type="'importPpt'"
      @hideModal="hideModalUploadPpt"
    />
    <modal-slide-limit
      v-if="showModalLimitSlides"
      @hide="hideModalSlideLimit"
    />

    <SlideCopy
      v-if="visibleModalCopySlide"
      :title="!showingSlideGrid ? `Slide ${targetSlide.index + 1}` : 'Copy to another presentation'"
      :get-items="targetSlide ? () => [targetSlide] : getActiveOrSelectedSlides"
      @hide="visibleModalCopySlide = false"
    />

    <aha-context-menu
      v-show="targetSlide"
      ref="aha-context-menu"
      :target="`slide-kebab-${indexSettingSlide}`"
      :x="targetX"
      :y="targetY"
    >
      <ul>
        <li
          v-show="targetSlide && targetSlide.id"
          class="context-menu-item context-menu-create new-slide-context-cta"
          @click.prevent="addNewSlide('Click on Context menu', targetSlide.index)"
        >
          <font-awesome-icon icon="plus" class="text-base-70 fa-fw" />
          <span>New slide</span>
        </li>
        <li
          v-show="targetSlide && targetSlide.id"
          class="context-menu-item context-menu-duplicate"
          @click.prevent="duplicateSingleSlide(targetSlide, targetSlide.index)"
        >
          <aha-icon
            name="duplicate"
            class="text-base-70"
            width="18"
            height="18"
            viewBox="0 0 20 20"
          />
          <span class="text-duplicate-slide">Duplicate </span>
          <ContextMenuShortcutKeys keyName="d-key" v-if="!isSmallScreen" />
        </li>
        <li
          v-if="targetSlide && targetSlide.id && targetSlide.type !== 'qrcode'"
          v-tooltip="{
            content: isGuestUser ? 'This feature is disabled in Demo Mode' : false,
            placement: 'right'
          }"
          class="context-menu-item"
          :class="{'disabled': isGuestUser}"
          :disabled="isGuestUser"
          @click.prevent="handleCopyIconClick(targetSlide)"
        >
          <font-awesome-icon icon="file-import" class="text-base-70 fa-fw" />
          <span>Copy to...</span>
        </li>
        <li
          v-if="targetSlide && targetSlide.id"
          class="relative context-menu-item"
          @click.stop
        >
          <font-awesome-icon icon="exchange-alt" class="text-base-70 fa-fw" />
          <span>Rearrange...</span>

          <div v-if="indexSettingSlide !== null">
            <select
              v-model="selectedOrder"
              class="slide-rearrange-options"
              @change="rearrangeSlides([targetSlide])"
            >
              <option disabled>
                Move slide to position:
              </option>
              <option
                v-for="(option,slideIndex) in $store.state.presentation.slides"
                :key="slideIndex"
                :value="slideIndex"
              >
                {{ slideIndex + 1 }}
                <span v-if="slideIndex == targetSlide.index">(current position)</span>
              </option>
            </select>
          </div>
        </li>
        <li
          v-if="targetSlide && targetSlide.id && targetSlide.type != 'leaderboard'"
          class="context-menu-item"
          @click.prevent="clearSingleSlide(targetSlide)"
        >
          <font-awesome-icon icon="redo" class="text-base-70 fa-fw" />
          <span>Reset results</span>
        </li>
        <div
          v-if="targetSlide && targetSlide.id"
          class="my-1 border-b border-solid border-base-30"
          @click.stop
        />
        <li
          class="context-menu-item"
          @click.prevent="deleteSingleSlide(targetSlide)"
        >
          <font-awesome-icon icon="trash-alt" class="text-red-100 fa-fw" />
          <span class="text-red-100">Delete</span>
        </li>
      </ul>
    </aha-context-menu>

    <ModalImportSheet v-if="openModalImportSheet" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Vue from 'vue'

import draggable from 'vuedraggable'
import * as Fraction from 'fraction.js'
import Config from '@/config'
import Util from '@/util'
import Socket from '@/socket'
import EventBus from '@/eventBus'
import gaCategories from '@/constant/gaCategories'
import Constants from '@/constant'

// api
import SlideApi from '@/api/slide'

import ModalImport from '@/components-v2/modals/Import.vue'
import ModalSlideLimit from '@/components-v2/modals/SlideLimit.vue'
import SlideCopy from '@/components-v2/common/slide-copy/SlideCopy.vue'
import SlideTypeIcon from '@/components-v2/common/slide-type-icon/SlideTypeIcon.vue'
import TakeOverToolbar from '@/components-v2/presentation-editor/TakeOverToolbar.vue'
import FreestyleThumbnailPreview from '@/components-v2/presentation-editor/side-left/FreestyleThumbnailPreview.vue'
import ModalDeleteSlide from '../../modals/DeleteSlide.vue'
import ModalClearDataSlide from '../../modals/ClearDataSlide.vue'
import mixpanelUtils from '@/utils/mixpanel.utils'
import ModalImportSheet from '@/components-v2/modals/ImportSheet.vue'
import ContextMenuShortcutKeys from '@/components-v2/presentation-editor/middle/right-click-menu/ContextMenuShortcutKeys.vue'
import {
  copyBackgroundCacheToSlides,
  copyQuestionImageCacheToSlides,
  copySlideOptionImageCache,
} from '@/utils/indexedDB/image.cache.utils'

const { PRESENTATION_EDITOR } = gaCategories
const throttleMs = 150

export default {
  components: {
    draggable,
    SlideTypeIcon,
    SlideCopy,
    ModalClearDataSlide,
    ModalDeleteSlide,
    ModalImport,
    ModalSlideLimit,
    TakeOverToolbar,
    FreestyleThumbnailPreview,
    ModalImportSheet,
    ContextMenuShortcutKeys,
  },
  data() {
    return {
      drag: false,
      showModalLimitSlides: false,
      selectedOrder: null,
      modalUploadPpt: false,
      windowInnerWidth: window.innerWidth,
      selectedSlideIds: [],
      isSelectMode: false,
      isSelectKeyPressed: false,
      isShiftKeyPressed: false,
      bus: new Vue(),
      lastSelectTime: 0,
      lastDeselectTime: 0,
      modalData: {},
      indexSettingSlide: null,
      showModalClearDataSlide: false,
      showModalSlideDelete: false,
      targetSlide: null,
      targetX: null,
      targetY: null,
      visibleModalCopySlide: false,
      isAddedEventDuplicateSlide: false,
      gridViewSelectedSlides: [],
    }
  },
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      showingSlideGrid: (state) => state.indicators.showingSlideGrid,
      isImportingSlides: (state) => state.importStatus === 2 || state.importStatus === 3,
      isGuestUser: (state) => state.currentUser.isGuest,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      openModalImportSheet: (state) => state.openModalImportSheet,
    }),
    dragOptions() {
      return {
        animation: 200,
        group: 'slide-group',
        disabled: false,
        delay: 0,
        delayOnTouchOnly: false,
        ghostClass: 'ghost',
        handle: '.slide-drag',
        multiDrag: true,
        multiDragKey: 'Alt',
        draggable: '.list-group-item',
      }
    },
    noCorrectAnswerTooltip() {
      return {
        content: 'You have not selected a correct answer for this Quiz question!',
        placement: 'top-end',
        boundariesElement: document.body,
      }
    },
    isSelectAll() {
      return this.getActiveOrSelectedSlides().length
       === this.$store.state.presentation.slides.length
    },
    isSmallScreen() {
      return window.innerWidth < 768
    },
    isEURegion() {
      return Config.region === Constants.euRegion
    },
    backgroundImage() {
      return (item) => {
        if (item.backgroundCache) return item.backgroundCache
        const extension = item.backgroundImage.name.split('.').pop()
        if (extension === 'gif') {
          return item.backgroundImage.large
        }
        return item.backgroundImage.thumbnail
      }
    },
    isResetResultsButtonDisabled() {
      return this.isSelectMode
    },
  },
  mounted() {
    const newSlides = this.$store.state.presentation.slides.map((item) => {
      return { ...item, isSlideCopyPopoverShowing: false }
    })

    this.$store.state.presentation.slides = newSlides
    const self = this
    EventBus.$on('addSlideLeaderboard', (data) => {
      self.addSlideLeaderboard(data)
    })

    EventBus.$on('removeSlideLeaderboard', () => {
      self.removeSlideLeaderboard()
    })

    EventBus.$on('slide-search-popup:add-new-slide', () => {
      self.addNewSlide()
    })

    EventBus.$on('sortSlidePresentation', () => {
      self.sortSlide()
      self.hideModalUploadPpt()

      if (this.isSelectMode) {
        this.toggleSelectMode()
        this.deselectAllSlides()
      }
    })

    EventBus.$on('openImport', () => {
      self.importPpt()
    })

    EventBus.$on('openModalLimitSlides', () => {
      this.showModalLimitSlides = true
    })

    EventBus.$on('updateLastSlide', () => {
      this.updateLastSlide()
    })

    EventBus.$on('makeSlideActive', (slide, isDelete, clickSource) => {
      this.makeSlideActive(slide, isDelete, clickSource)
    })

    if (this.$store.state.isReachLimitSlides) {
      this.showModalLimitSlides = true
    }

    this.addEventListenDuplicateSlide()
    document.addEventListener('keydown', this.onKeyDown)
    document.addEventListener('keyup', this.onKeyUp)

    EventBus.$on('dragBlockContentSlide', () => {
      this.removeEventListenDuplicateSlide()
    })

    window.onblur = this.exitSelectMode

    // Handle SortableJs uncatched errors
    window.onerror = (msg) => {
      if (msg.indexOf('TypeError:') > -1) {
        this.$store.dispatch('setSyncPresentation', 3)
      }
    }
    // Will be used by the Export PDF server, to screenshot a single slide (instead of all slides)
    window.selectSingleSlideById = this.selectSingleSlideById
  },
  destroyed() {
    EventBus.$off('sortSlidePresentation')
    EventBus.$off('addSlideLeaderboard')
    EventBus.$off('removeSlideLeaderboard')
    EventBus.$off('openModalLimitSlides')
    EventBus.$off('updateLastSlide')
    EventBus.$off('slide-search-popup:add-new-slide')

    document.removeEventListener('keydown', this.onKeyDown)
    document.removeEventListener('keyup', this.onKeyUp)
    this.removeEventListenDuplicateSlide()
    this.setShowingSlideGridAction(false)
    this.isShiftKeyPressed = false
    this.isSelectKeyPressed = false

    window.onblur = () => {}
    window.onerror = () => {}
  },
  methods: {
    ...mapActions([
      'clearHistory',
      'setShowingSlideGridAction',
      'setSelectedSlideIdsAction',
      'updateSlideActiveAction',
    ]),
    focusNoteAndMakeSlideActive(item) {
      this.deselectAllSlides()
      this.makeSlideActive(item)
      window.setTimeout(() => {
        EventBus.$emit('slide-notes:focus-input')
      }, 200) // makeSlideActive() has a 150ms timeout, so this has to be higher
    },
    openSettingSlide(index, item, event) {
      if (this.isDisableEditPresentation) return
      this.indexSettingSlide = index
      this.targetSlide = item ? { ...item, index } : null

      // Select slide & open context menu in clicked point
      if (event) {
        this.targetX = event.x
        this.targetY = event.y
        this.deselectAllSlides()

        // Check for active slide first to prevent reload
        if (this.$store.state.slideActive.id !== item.id) {
          this.makeSlideActive(item)
        }
      } else {
        this.targetX = null
        this.targetY = null
      }
      this.$refs['aha-context-menu'].show()
    },
    hideSettingSlide() {
      this.indexSettingSlide = null
      this.targeSlide = null
    },
    getSlideBgSize(bgSize) {
      if (!bgSize) return 'bg-cover'
      return 'bg-contain'
    },
    isSlideSelected(slide) {
      return this.selectedSlideIds.some((id) => id && slide.id === id)
    },

    exitSelectMode() {
      setTimeout(() => {
        this.isSelectKeyPressed = false
        this.isSelectMode = false
        document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Alt' }))
      })
    },

    toggleSelectMode() {
      this.isSelectMode = !this.isSelectMode
      if (this.isSelectMode) {
        this.cleanNewSlides()
        if (this.selectedSlideIds.length === 0) {
          this.selectSlides([this.$store.state.slideActive.id])
        }
        setTimeout(() => {
          document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Alt' }))
          this.isSelectKeyPressed = true
        })
      } else {
        setTimeout(() => {
          document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Alt' }))
          this.isSelectKeyPressed = false
        })
      }

      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        this.isSelectMode
          ? 'Grid Menu > Click Select…'
          : 'Grid Menu > Click Done',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
    },

    clickSlideLeft() {
      this.addEventListenDuplicateSlide()
    },
    clickOutsideSlideLeft() {
      this.removeEventListenDuplicateSlide()
    },

    addEventListenDuplicateSlide() {
      if (this.isAddedEventDuplicateSlide) {
        return
      }
      document.addEventListener('keydown', this.onListenDuplicateSlide)
      this.isAddedEventDuplicateSlide = true
    },

    removeEventListenDuplicateSlide() {
      document.removeEventListener('keydown', this.onListenDuplicateSlide)
      this.isAddedEventDuplicateSlide = false
    },

    onListenDuplicateSlide(evt) {
      if (evt && evt.code === 'KeyD' && (evt.ctrlKey || evt.metaKey)) {
        evt.preventDefault()
        this.duplicateSlidesByShortKey()
      }
    },
    async duplicateSlidesByShortKey() {
      const selectedSlides = this.getActiveOrSelectedSlides()
      const maxIndex = Math.max(...selectedSlides
        .map((slide) => this.$store.state.presentation.slides.findIndex((s) => s.id === slide.id)))
      if (selectedSlides.length > 0) {
        await this.duplicateSlides(selectedSlides, maxIndex)
        this.updateLastSlide()
        selectedSlides.forEach((item) => {
          Util.gaTrackEvent(
            PRESENTATION_EDITOR,
            'Slide Actions > Duplicate button',
            'Short key',
            item.id,
            {
              slideType: item.type,
            },
          )
        })
      }
    },

    onKeyDown(evt) {
      // Trigger Alt for both Control & Meta key,
      // so we can use Control/Command & Alt/Option to select
      const isFocusingOnAnInput = document.activeElement && document.activeElement.nodeName === 'INPUT'
      if (isFocusingOnAnInput) return
      if (evt && (evt.key === 'Control' || evt.key === 'Meta')) {
        document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Alt' }))
        this.isSelectKeyPressed = true
      }

      // Exit select mode if using tab
      if (evt && (evt.key === 'Tab')) {
        this.exitSelectMode()
      }

      if (evt && (evt.key === 'Shift')) {
        this.isShiftKeyPressed = true
      }
    },

    onKeyUp(evt) {
      if (evt && (evt.key === 'Control' || evt.key === 'Meta')) {
        document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Alt' }))
        this.isSelectKeyPressed = false

        if (this.isSelectMode) {
          this.toggleSelectMode()
        }
      }

      if (evt && (evt.key === 'Shift')) {
        this.isShiftKeyPressed = false
      }
    },

    openSlideGrid() {
      this.setShowingSlideGridAction(true)
      Util.gaTrackEvent(PRESENTATION_EDITOR, 'Left Sidebar > Click open slide grid', `Presentation: ${this.$store.state.presentation.id}`)
    },

    closeSlideGrid() {
      this.setShowingSlideGridAction(false)
      if (this.isSelectMode) {
        this.toggleSelectMode()
      }
    },

    cleanNewSlides() {
      this.$store.state.presentation = {
        ...this.$store.state.presentation,
        slides: this.$store.state.presentation.slides.filter((slide) => !!slide.id),
      }
      this.selectedSlideIds = this.selectedSlideIds.filter((id) => !!id)
    },

    onDragStart() {
      if (this.isBackstage) return
      this.drag = true
    },

    onDragEnd() {
      if (this.isBackstage) return
      this.drag = false
    },

    selectToDrag(evt, notUpdateActive) {
      // Too fast, not human
      if (this.isSelectKeyPressed && !notUpdateActive) {
        this.lastSelectTime = Date.now()
        if (this.lastSelectTime - this.lastDeselectTime < throttleMs) {
          this.callDeselect(evt.item, true)
          return
        }
      }

      // Prevent switching slide when uploading image is in progress
      if (this.$store.state.imageUploading) {
        Util.showToastError('Image upload is on progress, please wait until it finished!')
        return
      }

      const slideId = this.getSlideIdFromEvt(evt)
      if (!this.selectedSlideIds.some((id) => id === slideId)) {
        this.selectedSlideIds.push(slideId)
      }

      if (!slideId && evt && evt.item) {
        const index = parseInt(evt.item.getAttribute('data-index'), 10)
        if (index > -1) {
          this.makeSlideActive(this.$store.state.presentation.slides[index])
        }
      }

      if (this.selectedSlideIds.length > 1) {
        this.cleanNewSlides()
      }

      if (!notUpdateActive) {
        // If not in multiple select mode, select only one
        if (!this.isSelectKeyPressed && !this.isShiftKeyPressed) {
          const slide = this.$store.state.presentation.slides
            .find((s) => s.id === slideId)

          if (slide) {
            this.deselectAllSlides()
            if (this.slideActive.id !== slideId) {
              this.makeSlideActive(slide)
            }
          }
        } else {
          const activeId = this.$store.state.slideActive.id
          const activeSlideNotInSelected = !this.selectedSlideIds
            .some((id) => id === activeId)

          this.activeSlideDetail(false)

          // If active slide is not in selected slides any more, active new one
          if (activeSlideNotInSelected) {
            if (this.isSelectKeyPressed) {
              this.selectSlides([activeId])
            } else {
              const firstSlideId = this.selectedSlideIds[0]
              const firstSlideIndex = this.$store.state.presentation.slides
                .findIndex((s) => s.id === firstSlideId)
              this.makeSlideActive(this.$store.state.presentation.slides[firstSlideIndex])
            }
          }
        }
      }
      this.setSelectedSlideIdsAction(this.selectedSlideIds)
    },

    deselectToDrag(evt, notUpdateActive) {
      // Too fast, not human
      if (this.isSelectKeyPressed && !notUpdateActive) {
        this.lastDeselectTime = Date.now()
        if (this.lastDeselectTime - this.lastSelectTime < throttleMs) {
          this.callSelect(evt.item, true)
          return
        }
      }

      const slideId = this.getSlideIdFromEvt(evt)
      const index = this.selectedSlideIds.findIndex((id) => id === slideId)
      if (index > -1) {
        this.selectedSlideIds.splice(index, 1)
      }
      this.setSelectedSlideIdsAction(this.selectedSlideIds)

      if (!notUpdateActive) {
        const slideActiveId = this.$store.state.slideActive.id
        if (this.isSelectKeyPressed && slideId === slideActiveId && this.selectedSlideIds.length) {
          const newActive = this.$store.getters.selectedSlides
            .filter((slide) => slide.id !== slideActiveId)[0]
          if (newActive && newActive.id) {
            this.makeSlideActive(newActive)
          }
        }
      }
    },
    getSlideIdFromEvt(evt) {
      if (!evt.item || !evt.item.id) {
        return null
      }

      const [, slideId] = evt.item.id.split('-')
      return parseInt(slideId, 10) || null
    },

    closeSlideCopyPopover() {
      const newSlides = this.$store.state.presentation.slides.map((item) => {
        return { ...item, isSlideCopyPopoverShowing: false }
      })

      this.$store.state.presentation.slides = newSlides
    },

    handleCopyIconClick(slide) {
      if (this.isGuestUser) return

      this.targetSlide = slide
      this.visibleModalCopySlide = true
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Slide Actions > Copy Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
      this.handleCopySlides(slide, true)
      this.hideSettingSlide()
    },

    copySlidesTo() {
      this.targetSlide = null
      this.visibleModalCopySlide = true
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Grid Menu > Copy Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )

      const selectedSlides = this.getActiveOrSelectedSlides()

      if (selectedSlides.length === 1 && !selectedSlides[0].id) {
        return
      }

      const lastSelected = selectedSlides[selectedSlides.length - 1]
      this.handleCopySlides(lastSelected, false)
    },

    handleCopySlides(slide, copySingleSlide) {
      const { isSlideCopyPopoverShowing } = slide
      const newSlides = this.$store.state.presentation.slides.map((item) => {
        if (item.id === slide.id) {
          return { ...item, isSlideCopyPopoverShowing: !isSlideCopyPopoverShowing, copySingleSlide }
        }

        return { ...item, isSlideCopyPopoverShowing: false, copySingleSlide: false }
      })

      this.$store.state.presentation.slides = newSlides
      this.visibleModalCopySlide = true
    },

    hideModalUploadPpt() {
      this.$store.state.openImportModal = false
    },

    importPpt() {
      this.$store.state.openImportModal = true
      if (this._isReachLimitSlides()) return
      Util.gaTrackEvent(
        Constants.gaCategories.PRESENTATION_EDITOR,
        'Import > Open modal',
      )
    },

    removeSlideLeaderboard() {
      this.deselectAllSlides()
      const index = Util.getIndexSlide(
        this.$store.state.presentation.slides,
        this.$store.state.slideActive.id,
      )
      const { id } = this.$store.state.presentation.slides[index + 1]
      this.$store.state.presentation.slides.splice(index + 1, 1)
      this.$store.dispatch('setSyncPresentation', 1)
      this.$http
        .put(Config.api.updateSlide + id, {
          deleted: true,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.$store.getters.isPresenting,
        })
        .then(
          () => {
            this.$store.dispatch('setSyncPresentation', 2)
            this.updateLastSlide()
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },

    activeSlideDetail(isDelete) {
      if (this.isSmallScreen && isDelete) {
        this.$store.state.activeModelDetailSlide = false
      } else {
        this.$store.state.activeModelDetailSlide = true
      }
    },

    resetContentSlideToolbar() {
      EventBus.$emit('show-freestyle-editor-toolbar', false)
      this.$store.state.selectingBlocks = []
    },

    makeSlideActive(item, isDelete, clickSource) {
      if (!item) return
      this.clearHistory()
      this.activeSlideDetail(isDelete)
      this.resetContentSlideToolbar()

      // Prevent multi-select on mobile
      if (this.isSmallScreen) {
        this.deselectAllSlides()
      }

      if (item.type) {
        item.activeTab = 2
      } else {
        item.activeTab = 1
      }
      if (item.type === 'pickAnswer') {
        item.hideResult = false
        item.showCorrectOption = false
      }
      if (item.id) {
        const isSwitchingContentSlide = item.type === 'freestyle' && item.id !== this.slideActive.id
        setTimeout(() => {
          this.$store.dispatch('updateSlideActive', {
            activeTab: isSwitchingContentSlide ? 2 : null,
            id: null,
          })
        }, 20)
        setTimeout(() => {
          this.$store.dispatch(
            'setSlideActive',
            JSON.parse(JSON.stringify(item)),
          )
          if (clickSource === 'report') {
            const container = this.$refs.leftScrollBar
            const el = document.getElementById(`slide-${item.id}`)
            if (container && el) {
              container.scrollTop = el.offsetTop - container.offsetTop
            }
          }
          EventBus.$emit('eventHandleSetValueTransition')
        }, 100)
      } else {
        this.$store.dispatch(
          'setSlideActive',
          JSON.parse(JSON.stringify(item)),
        )
        EventBus.$emit('eventHandleSetValueTransition')
      }
      if (!item.id) {
        this.openSlideSearchPopup()
        return
      }

      // Select active, too
      if (!this.selectedSlideIds.some((id) => id === item.id)) {
        this.selectSlides([item.id])
      }

      EventBus.$emit('updateNextSlide', item.id)

      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Select Slide > Make Active',
        `Presentation: ${this.$store.state.presentation.id}`,
        null,
        {
          slideId: item.id,
          convertedFromDocument: item.type === 'freestyle' && item.image !== null,
        },
      )
    },

    _createSlideLeaderboard(item, cb) {
      this.$http
        .post(Config.api.createSlide, {
          presentationId: this.$store.state.presentation.id,
          type: item.type,
          order: item.order,
          socketId: Socket.getSocketId(),
          textColour: item.textColour,
          baseColour: item.baseColour,
          backgroundImage: item.backgroundImage,
          visibility: item.visibility,
        })
        .then((res) => {
          item.id = res.body.id
          cb(item)
        })
        .catch((error) => {
          Util.handleError(error.body.message)
        })
    },

    addSlideLeaderboard(data) {
      this.deselectAllSlides()
      const { slideActive } = this.$store.state
      const defaultBlack = '#313131'
      const defaultWhite = '#ffffff'
      const _sortSlide = () => {
        this.$store.state.presentation.slides.forEach((item, key) => {
          item.order = key + 1
        })
      }
      const _newOrder = (index) => {
        for (let i = 0; i < this.$store.state.presentation.slides.length; i++) {
          if (i > index) {
            this.$store.state.presentation.slides[i].order = i + 2
          }
        }
        this.$store.state.presentation.slides.push()
      }
      let index = this.$store.state.presentation.slides
        .findIndex((item) => item.id === this.$store.state.slideActive.id)

      if (data && data.lastSlide) {
        for (let i = 0; i < this.$store.state.presentation.slides.length; i++) {
          if (this.$store.state.presentation.slides[i].type === 'pickAnswer') {
            index = i
          }
        }
      }

      if (
        index === -1
        || this.$store.state.presentation.slides.length - 1 === index
      ) {
        const slide = {
          index: this.$store.state.presentation.slides.length,
          activeTab: 1,
          order: this.$store.state.presentation.slides.length + 1,
          typeObj: {
            type: 'leaderboard',
            name: 'Leaderboard',
          },
          type: 'leaderboard',
          audioShowControl: true,
          audioAudienceShowControl: true,
          textColour: slideActive.textColour || defaultBlack,
          baseColour: slideActive.baseColour || defaultWhite,
          backgroundImage: slideActive.backgroundImage,
          backgroundCache: slideActive.backgroundCache,
          cropperDataCache: slideActive.cropperDataCache,
          originBackgroundCache: slideActive.originBackgroundCache,
          visibility: slideActive.visibility,
        }

        this._createSlideLeaderboard(slide, (data) => {
          if (slideActive.backgroundCache) {
            copyBackgroundCacheToSlides(slideActive, [data])
          }
          this.$store.state.presentation.slides.push(data)
          EventBus.$emit('slide-search-popup:unlock-add-slide')
          setTimeout(() => {
            const container = this.$refs.leftScrollBar
            container.scrollTop = container.scrollHeight
          }, 200)

          this.sortSlide()
        })

        _sortSlide()
      } else {
        const slide = {
          order: index + 2,
          activeTab: 1,
          typeObj: {
            type: 'leaderboard',
            name: 'Leaderboard',
          },
          type: 'leaderboard',
          textColour: slideActive.textColour || defaultBlack,
          baseColour: slideActive.baseColour || defaultWhite,
          backgroundImage: slideActive.backgroundImage,
          backgroundCache: slideActive.backgroundCache,
          cropperDataCache: slideActive.cropperDataCache,
          originBackgroundCache: slideActive.originBackgroundCache,
          visibility: slideActive.visibility,
        }
        _sortSlide()
        _newOrder(index)
        this._createSlideLeaderboard(slide, (data) => {
          if (slideActive.backgroundCache) {
            copyBackgroundCacheToSlides(slideActive, [data])
          }
          this.$store.state.presentation.slides.splice(index + 1, 0, data)
          EventBus.$emit('slide-search-popup:unlock-add-slide')
          this.sortSlide()
        })
      }
      Util.gaTrackEvent(
        'Presentation Editing',
        'New slide leaderboard',
        'Auto add leaderboard',
      )
    },

    addNewSlide(label = 'Click on New Slide button', focusedIndex = null) {
      if (this._isReachLimitSlides()) return
      this.deselectAllSlides()
      const { slideActive } = this.$store.state
      const defaultBlack = '#313131'
      const defaultWhite = '#ffffff'
      const _sortSlide = () => {
        this.$store.state.presentation.slides.forEach((item, key) => {
          item.order = key + 1
        })
      }
      let index
      let slide

      if (focusedIndex !== null) {
        index = focusedIndex === -1 ? this.presentation.slides.length - 1 : focusedIndex
        slide = {
          id: null,
          activeTab: 1,
          textColour: this.presentation.slides[index].textColour || defaultBlack,
          baseColour: this.presentation.slides[index].baseColour || defaultWhite,
          backgroundImage: this.presentation.slides[index].backgroundImage,
          visibility: this.presentation.slides[index].visibility,
          timestamp: new Date().getTime(),
          backgroundCache: this.presentation.slides[index].backgroundCache,
          cropperDataCache: this.presentation.slides[index].cropperDataCache,
          originBackgroundCache: this.presentation.slides[index].originBackgroundCache,
        }
      } else {
        index = this.$store.state.presentation.slides.findIndex((item) => item.id === slideActive.id)
        slide = {
          id: null,
          activeTab: 1,
          textColour: this.slideActive.textColour || defaultBlack,
          baseColour: this.slideActive.baseColour || defaultWhite,
          backgroundImage: this.slideActive.backgroundImage,
          visibility: this.slideActive.visibility,
          timestamp: new Date().getTime(),
          backgroundCache: this.slideActive.backgroundCache,
          cropperDataCache: this.slideActive.cropperDataCache,
          originBackgroundCache: this.slideActive.originBackgroundCache,
        }
      }

      if (
        index === -1
        || this.$store.state.presentation.slides.length - 1 == index
      ) {
        slide.index = this.$store.state.presentation.slides.length
        slide.order = this.$store.state.presentation.slides.length + 1
        this.$store.state.presentation.slides.push(slide)
        this.makeSlideActive(slide)
        setTimeout(() => {
          const container = this.$refs.leftScrollBar
          container.scrollTop = container.scrollHeight
        }, 200)

        _sortSlide()
      } else if (
        this.$store.state.presentation.slides[index + 1].type
            === 'leaderboard'
          && this.$store.state.slideActive.type === 'pickAnswer'
      ) {
        slide.order = index + 3
        _sortSlide()
        this.$store.state.presentation.slides.splice(index + 2, 0, slide)
        this.makeSlideActive(slide)
      } else {
        slide.order = index + 2
        _sortSlide()
        this.$store.state.presentation.slides.splice(index + 1, 0, slide)
        this.makeSlideActive(slide)
      }

      this.sortSlide()
      Util.gaTrackEvent(
        'Presentation Editing',
        'New slide',
        label,
      )
      this.openSlideSearchPopup()
    },

    selectSingleSlideById(slideId) {
      const index = this.$store.state.presentation.slides.findIndex((item) => item.id === slideId)
      if (index !== -1) {
        const slide = this.$store.state.presentation.slides[index]
        this.makeSlideActive(slide)
      }
    },

    openSlideSearchPopup() {
      if (this.isEURegion) return
      const { indicators } = this.$store.state
      if (indicators.showingSlideGrid) return
      // const index =
      //   this.$store.state.presentation.slides.findIndex((item) => item.id === slideActive.id)
      // calculate arrow pos based off new slide's index
      // const slideHeight = 114
      // const container = this.$refs.leftScrollBar
      // let arrowPos = slideHeight + (index + 1) * slideHeight - slideHeight / 2 + 30
      // arrowPos -= container.scrollTop

      EventBus.$emit('slide-search-popup:open')
    },

    async handleDragAndDropSlide(event) {
      if (this.isBackstage) return
      const { slides } = this.$store.state.presentation
      this.selectedSlideIds = []

      if (slides.length < 2 || !event || !event.moved) return

      let moved = []
      if (Array.isArray(event.moved)) {
        if (!event.moved) {
          return
        }

        moved = event.moved
          .map((e) => ({
            id: e.element.id,
            order: e.element.order,
            oldIndex: e.oldIndex,
            newIndex: e.newIndex,
          }))
      } else {
        if (!event.moved.element) {
          return
        }

        moved = [{
          id: event.moved.element.id,
          order: event.moved.element.order,
          oldIndex: event.moved.oldIndex,
          newIndex: event.moved.newIndex,
        }]
      }

      const movedSlides = this.calculateSlideOrderMultiple(slides, moved)
      const movedSlidesMap = movedSlides
        .map((s) => ({ [s.id]: s.order }))
        .reduce((a, b) => ({ ...a, ...b }), {})

      // Update back to slides
      moved.forEach((slide) => {
        if (this.$store.state.presentation.slides[slide.newIndex]) {
          this.$store.state.presentation.slides[slide.newIndex].order = movedSlidesMap[slide.id]
        }
      })

      // Make first slide active
      this.makeSlideActive(this.$store.state.presentation.slides[moved[0].newIndex])

      try {
        this.$store.dispatch('setSyncPresentation', 1)

        await SlideApi.updateSlides({
          presentationId: this.$store.state.presentation.id,
          slides: movedSlides,
        })

        EventBus.$emit('sort-slide')
        this.updateLastSlide()

        this.$store.dispatch('setSyncPresentation', 2)
        Util.gaTrackEvent(PRESENTATION_EDITOR, 'Left Sidebar > Drag slides success', `Moved slides: ${moved.length}`)
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)
        Util.showToastError(`Fail to rearrange ${moved.length} slide${moved.length > 1 ? 's' : ''}`)
        Util.gaTrackEvent(PRESENTATION_EDITOR, 'Left Sidebar > Drag slides error', `Error: ${JSON.stringify(error)}`)
      }

      this.deselectAllSlides()
    },

    calculateSlideOrderMultiple(slides, moved) {
      // Use fraction instead of average for calculate the order in between
      const indexBefore = moved[0].newIndex - 1
      const indexAfter = moved[moved.length - 1].newIndex + 1

      let nBefore = 0
      let dBefore = 1
      if (indexBefore >= 0) {
        const fBefore = new Fraction(slides[indexBefore].order)
        nBefore = fBefore.n
        dBefore = fBefore.d
      }

      let nAfter = slides.length
      let dAfter = 0
      if (indexAfter < slides.length) {
        const fAfter = new Fraction(slides[indexAfter].order)
        nAfter = fAfter.n
        dAfter = fAfter.d
      }

      return moved
        .map((s) => {
          const order = new Fraction(nBefore + nAfter, dBefore + dAfter)
          nBefore = order.n
          dBefore = order.d
          return { id: s.id, order: order.valueOf() }
        })
    },

    sortSlide() {
      const sort = []
      this.$store.state.presentation.slides.forEach((item, key) => {
        item.order = key + 1
        if (item.id) {
          sort.push({
            order: key + 1,
            id: item.id,
          })
        }
      })

      if (!sort.length || this.$store.state.isAdmin) return
      this.$store.dispatch('setSyncPresentation', 1)
      this.$http
        .put(Config.api.sortSlide + this.$store.state.presentation.id, {
          sort,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
        })
        .then(
          () => {
            this.$store.dispatch('setSyncPresentation', 2)
            this.updateLastSlide()
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },

    updateLastSlide() {
      const idLastSlide = Util.getLastSlide(this.$store.state.presentation.slides)
      const payload = {
        socketId: Socket.getSocketId(),
      }
      if (idLastSlide && idLastSlide != this.$store.state.presentation.lastSlide) {
        payload.lastSlide = idLastSlide
        this.$store.state.presentation.lastSlide = idLastSlide
        this.$http.put(
          Config.api.updatePresentation + this.$store.state.presentation.id,
          payload,
        ).then(() => {}, () => {})
      }
    },

    clearSingleSlide(item) {
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Slide Actions > Erase Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
      this.clearSlidesConfirm([item])
      this.hideSettingSlide()
    },

    clearSelectedSlides() {
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Grid Menu > Erase Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )

      const selectedSlides = this.getActiveOrSelectedSlides()
      this.clearSlidesConfirm(selectedSlides)
    },

    deleteSingleSlide(item) {
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Slide Actions > Delete Button',
        `Presentation: ${this.presentation.id}`,
      )
      this.deleteSlidesConfirm([item])
      this.hideSettingSlide()
    },

    deleteSelectedSlides() {
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Grid Menu > Delete Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )

      const selectedSlides = this.getActiveOrSelectedSlides()
      this.deleteSlidesConfirm(selectedSlides)
    },

    clearSlidesConfirm(slides) {
      this.gridViewSelectedSlides = slides
      if (slides.length && (!slides[0] || !slides[0].id)) {
        return
      }
      this.showModalClearDataSlide = true
    },

    deleteSlidesConfirm(slides) {
      if (slides.length && (!slides[0] || !slides[0].id)) {
        this.handleDeleteEmptySlidesInstantly()
        return
      }

      const title = slides.length === 1
        ? 'Are you sure that you want to delete this slide?'
        : `Are you sure that you want to delete these ${slides.length} slides?`
      const content = slides.length === 1
        ? 'This slide and any response data will be lost.'
        : 'These slides and any response data will be lost.'
      this.modalData = {
        slides,
        title,
        content,
      }
      this.showModalSlideDelete = true
    },

    handleCloseModalDeleteSlide() {
      this.showModalSlideDelete = false
      Util.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Modal delete slide > Close modal',
      )
    },

    handleCloseModalClearDataSlide() {
      this.showModalClearDataSlide = false
      Util.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Modal clear data slide > Close modal',
      )
    },

    handleDeleteEmptySlidesInstantly() {
      const index = this.presentation.slides.findIndex((s) => !s.id)
      this.presentation.slides.splice(index, 1)
      setTimeout(() => {
        this.makeSlideActive(
          this.presentation.slides[index ? index - 1 : index],
          true,
        )
        this.$store.dispatch('updateSlideActive', {
          activeTab: null,
        })
      }, 100)
    },

    getActiveOrSelectedSlides() {
      const { slides } = this.$store.state.presentation
      if (!slides) return []
      slides.forEach((slide, index) => {
        slide.index = index
      })
      const selectedIds = this.selectedSlideIds.length
        ? this.selectedSlideIds
        : [this.$store.state.slideActive.id]
      return selectedIds
        .map((id) => this.$store.state.presentation.slides.find((s) => s.id === (id || null)))
        .sort((a, b) => a.order - b.order)
    },

    async duplicateSelectedSlides() {
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Grid Menu > Duplicate button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )

      const selectedSlides = this.getActiveOrSelectedSlides()
      const maxIndex = Math.max(...selectedSlides
        .map((slide) => this.$store.state.presentation.slides.findIndex((s) => s.id === slide.id)))
      await this.duplicateSlides(selectedSlides, maxIndex)
      this.updateLastSlide()
    },

    async duplicateSingleSlide(item, index) {
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Slide Actions > Duplicate button',
        'Click duplicate',
        item.id,
        {
          slideType: item.type,
        },
      )
      await this.duplicateSlides([item], index)
      this.hideSettingSlide()
      this.updateLastSlide()
    },

    async duplicateSlides(items, index) {
      if (this._isReachLimitSlides()) return
      const itemsToDuplicate = items.filter((item) => item.id && !item.loading)

      if (!itemsToDuplicate.length) {
        return
      }

      itemsToDuplicate.forEach((i) => {
        i.loading = true
      })

      try {
        this.$store.dispatch('setSyncPresentation', 1)
        const oldSlides = itemsToDuplicate.sort((a, b) => a.order - b.order)

        const response = await SlideApi.duplicateSlides({
          id: itemsToDuplicate.map((i) => i.id),
          presentationId: this.$route.params.id,
        })
        const slides = response.body

        let newIndex = index + 1
        slides.forEach((slide, i) => {
          if (slide.SlideOptions && slide.SlideOptions.length > 0) {
            slide.SlideOptions.sort((a, b) => a.order - b.order)
            slide.SlideOptions.forEach((slideOption, j) => {
              const originSlideOption = oldSlides[i].SlideOptions[j]
              copySlideOptionImageCache(originSlideOption, slideOption)
            })
          }

          // Parse some unparsed data
          if (slide.additionalFields) {
            slide.additionalFields = JSON.parse(slide.additionalFields)
          }
          if (slide.otherCorrectQuiz) {
            slide.otherCorrectQuiz = JSON.parse(slide.otherCorrectQuiz)
          } else {
            slide.otherCorrectQuiz = []
          }
          if (oldSlides[i].canvasBlocks) {
            slide.canvasBlocks = JSON.parse(JSON.stringify(oldSlides[i].canvasBlocks))
          }

          if (oldSlides[i].backgroundCache) {
            copyBackgroundCacheToSlides(oldSlides[i], [slide])
          }
          if (oldSlides[i].image) {
            copyQuestionImageCacheToSlides(oldSlides[i], [slide])
          }

          // Icons & some more
          slide.typeObj = oldSlides[i].typeObj

          this.$store.state.presentation.slides.splice(
            newIndex,
            0,
            slide,
          )
          newIndex += 1
        })

        this.$store.dispatch('setSyncPresentation', 2)
        // Select new slides
        setTimeout(() => {
          this.makeSlideActive(this.$store.state.presentation.slides[index + 1], null, 'duplicate')
          this.selectSlides(slides.map((s) => s.id))
        }, 0)
        Util.gaTrackEvent('Presentation Editor', 'Create new slide', 'Side left > Slide menu > Duplicate', this.presentation.id, {
          ...mixpanelUtils.getPresentationContext(this.$store.state.presentation),
          copiedSlideIds: itemsToDuplicate.map((i) => i.id),
        })
      } catch (err) {
        if (Util.handleError(err.body.message)) {
          this.$store.dispatch('setSyncPresentation', 2)
        } else {
          this.$store.dispatch('setSyncPresentation', 3)
        }
        Util.showToastError(`Fail to duplicate ${itemsToDuplicate.length} slide${itemsToDuplicate.length > 1 ? 's' : ''}`)
      }

      itemsToDuplicate.forEach((i) => {
        i.loading = false
      })
      this.deselectAllSlides()
    },

    callSelect(item) {
      if (this.drag) {
        return
      }

      const evt = document.createEvent('Event')
      evt.initEvent('select', true, true)
      evt.item = item
      evt.items = []

      if (document.querySelector('.list-group')) {
        document.querySelector('.list-group').dispatchEvent(evt)
      }

      this.bus.$emit('select', item)
      this.selectToDrag(evt, true)
    },

    callDeselect(item) {
      if (this.drag) {
        return
      }

      const evt = document.createEvent('Event')
      evt.initEvent('select', true, true)
      evt.item = item
      evt.items = []
      document.querySelector('.list-group').dispatchEvent(evt)

      this.bus.$emit('deselect', item)
      this.deselectToDrag(evt, true)
    },

    deselectAllSlides() {
      // Trigger mouseup in 0, 0 to deselect all for now
      document.dispatchEvent(new MouseEvent('mouseup', { x: 0, y: 0 }))
      this.selectedSlideIds = []
      this.setSelectedSlideIdsAction([])
    },

    selectSlides(ids) {
      ids
        .map((id) => document.getElementById(`slide-${id}`))
        .map((item) => this.callSelect(item))
    },

    async rearrangeSelectedSlides() {
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Grid Menu > Rearrange Button > Click',
        `Presentation: ${this.$store.state.presentation.id}`,
      )

      const selectedSlides = this.getActiveOrSelectedSlides()
      await this.rearrangeSlides(selectedSlides)
    },

    async rearrangeSingleSlide(slide) {
      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        'Slide Actions > Rearrange Button > Click',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
      await this.rearrangeSlides(slide)
    },

    async rearrangeSlides(selected) {
      this.$refs['aha-context-menu'].hide()
      const { slides } = this.$store.state.presentation

      if (!selected || slides.length < 2) return

      const toIndex = this.selectedOrder
      this.selectedOrder = -1

      const moved = selected
        .map((s, i) => ({
          id: s.id,
          order: s.order,
          newIndex: toIndex + i,
        }))

      this.deselectAllSlides()

      // Delete old ones
      moved.forEach((slide) => {
        slide.oldIndex = slides.findIndex((s) => s.id === slide.id)
        this.$store.state.presentation.slides.splice(slide.oldIndex, 1)
      })

      // Add new ones
      this.$store.state.presentation.slides.splice(toIndex, 0, ...selected)

      // Calculate order
      const movedSlides = this.calculateSlideOrderMultiple(slides, moved)
      const movedSlidesMap = movedSlides
        .map((s) => ({ [s.id]: s.order }))
        .reduce((a, b) => ({ ...a, ...b }), {})

      // Update back to slides
      moved.forEach((slide) => {
        if (this.$store.state.presentation.slides[slide.newIndex]) {
          this.$store.state.presentation.slides[slide.newIndex].order = movedSlidesMap[slide.id]
        }
      })

      if (moved.find((s) => s.id === this.slideActive.id)) {
        this.updateSlideActiveAction({
          index: moved[0].newIndex,
        })
        this.makeSlideActive(this.presentation.slides[moved[0].newIndex])
      }

      try {
        this.$store.dispatch('setSyncPresentation', 1)

        await SlideApi.updateSlides({
          presentationId: this.$store.state.presentation.id,
          slides: movedSlides,
        })

        EventBus.$emit('sort-slide')
        this.updateLastSlide()
        this.$store.dispatch('setSyncPresentation', 2)
      } catch (error) {
        Util.showToastError(`Fail to rearrange ${moved.length} slide${moved.length > 1 ? 's' : ''}`)
        this.$store.dispatch('setSyncPresentation', 3)
      }

      // Call again because we make one active above
      this.deselectAllSlides()
    },

    getActiveSlide(item) {
      if (!item.id) {
        if (item.order
         && item.order === this.$store.state.slideActive.order
         && item.title === this.$store.state.slideActive.title) {
          return true
        }
        return false
      } if (item.id && this.$store.state.slideActive.id == item.id) {
        return true
      }
      return false
    },

    _isReachLimitSlides() {
      if (this.presentation.slides.length >= Config.MAX_NUMBER_OF_SLIDE) {
        this.showModalLimitSlides = true
        this.$store.state.openImportModal = false
        return true
      }
      return false
    },

    hideModalSlideLimit() {
      this.showModalLimitSlides = false
      if (this.$store.state.isReachLimitSlides) {
        this.$store.state.isReachLimitSlides = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.aha-slide-setting-icon {
  font-size: 0.6rem;
  @apply text-base-70;
}

.aha-slide-left-top {
  height: 52px;
  min-height: 52px;
  @apply border-b border-base-30 flex;
}

.aha-slide-item {
  padding-left: 2.3rem;
  @apply pt-3 pb-3 relative;
  .aha-slide-order {
    left: 16px;
    top: 8px;
    font-size: 11px;
    @apply absolute text-base-90;
  }
  .aha-slide-has-note {
    left: 11px;
    top: 30px;
    @apply absolute text-secondary-40 hover:text-brand-b100 cursor-pointer;
  }
  .aha-slide-setting {
    font-size: 9px;
    left: 7px;
    @apply absolute bottom-2 pl-3 pt-3 pr-3 cursor-pointer;

    &:hover {
      .aha-slide-setting-icon {
        @apply text-primary-90;
      }
    }
  }
  .aha-slide-content {
    @apply w-40 rounded relative cursor-pointer flex flex-col;
    height: calc(10rem / 16 * 9);
    box-shadow: 0 0 1px 1px rgb(180, 188, 207);
    &.is-content-slide {
      overflow: hidden;
    }
    .aha-slide-bg-image {
      @apply absolute w-full h-full top-0 left-0 bg-no-repeat bg-center rounded;
    }
    .aha-slide-title {
      @apply pl-2 pr-2 text-xs font-bold min-h-6 relative;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
      overflow: hidden;
      line-height: 0.9rem;
      max-height: 2rem;
      height: 2rem;
    }

    &:hover {
      box-shadow: 0 0 0 2px $primary-color;
    }
  }

  &.leaderboard {
    .aha-slide-title {
      @apply min-h-8;
    }
    .aha-slide-type-icon {
      top: 42px;
    }
  }

  &.create-context-item {
    .aha-slide-content {
      box-shadow: none;
    }
  }
}

.active-slide, .select-slide {
  @apply bg-primary-70;

  .aha-slide-content {
    box-shadow: 0 0 0 2px #1279e0;
  }

  .aha-slide-order {
    @apply text-primary-100 font-bold;
  }
}

.aha-button-grid-view {
  @apply flex flex-none justify-center;
  @apply flex items-center w-52 h-full;

  .close-gridview {
    &:hover {
      .icon-close {
        @apply text-primary-90;
      }
    }
  }
  span {
    @apply hover:text-primary-90 cursor-pointer;
  }
}

.aha-side-left-bottom {
  @apply flex border-t border-base-30 px-2 py-4 relative;
}
.slide-drag {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  top: 0;
}
.slide-rearrange-options {
  @apply opacity-0 absolute w-full h-full left-0 top-0 m-0 cursor-pointer;
}

.reset-results-button {
  @apply mb-1;
}

.aha-slide-grid-action {
  @apply hidden flex-1;
  animation: opengrid 0.3s;

  li {
    transition: all .1s;
    margin-right: 2.25rem;
    @apply inline cursor-pointer;

    &.disabled {
      @apply cursor-not-allowed hover:text-base-90;
      a {
        opacity: 0.6;
        pointer-events: none;
        cursor: not-allowed;
        &:hover {
          color: #4B4B4B !important;
        }
      }
    }

    span {
      transition: all .1s;
    }

    &:not(.disabled):hover {
      @apply text-primary-90 cursor-pointer;

      span {
        @apply text-primary-90 cursor-pointer;
      }
    }

    &.aha-slide-delete-button:hover {
      @apply text-red-50;
      span {
        @apply text-red-50;
      }
    }

    select {
      transition: all .1s;
      @apply text-base-90 cursor-pointer;
    }
  }

  &.not-allow {
    li, span, a {
      cursor: not-allowed;
    }
  }
}

@keyframes showgriditem {
  0% {  @apply w-52; }
  99% {   @apply w-52; }
  100% {  @apply w-full;}
}

@keyframes opengrid {
  0% { opacity: 0; position: absolute;  }
  99% { opacity: 0; position: absolute; }
  100% { opacity: 1; position: unset;}
}

.aha-slide-grid-close {
  @apply hidden justify-center items-center pl-8 cursor-pointer text-base-90 pr-8;
  &:hover {
    @apply text-primary-90;

    svg {
      @apply text-primary-90;
    }
  }
}

.show-grid-slide {
  .aha-slide-grid-action {
    @apply flex;
  }

  .aha-slide-item {
    @apply py-3;
  }
  .aha-slide-grid-close {
    @apply flex;
  }
}

.aha-slide_infoicon {
  @apply rounded-full;
  background-color: #fff;
}

.list-group-grid {
  animation: showgriditem 0.4s;
  @apply grid justify-center content-center items-center;
  grid-template-columns: repeat(auto-fit, minmax(160px, 224px));
}

.aha-slide-title.aha-slide-title-bg {
  background-color: rgba(0,0,0,.38);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  &.dark {
    background-color: hsla(0,0%,100%,.9);
  }
}

.overlay-disable-top-side-left, .overlay-disable-grid-action {
  @apply bg-base-0 opacity-50 absolute top-0 left-0 w-full h-full;
  z-index: 9;
}

@media (max-width: 1453px) {
  .aha-slide-grid-action  {
    li {
      @apply mr-2;
    }
  }
}
@media (max-width: $ipad-breakpoint) {
  .aha-slide-grid-action  {
    li {
      @apply hidden;
    }
  }
}
@media (max-width: 1515px) {
  .aha-slide-grid-action  {
    li {
      span {
        @apply hidden;
      }
    }
  }
}

@media (max-width: $ipad-breakpoint) {
  .aha-side-left-bottom {
    display: none;
  }
}

@media (max-width: 765px) {
  .show-grid-slide {
    .aha-slide-left-top {
      @apply justify-start;
    }
    .aha-slide-grid-action, .aha-slide-grid-close {
      @apply hidden;
    }
  }
}

.take-over {
  display: none;
}

@media (max-width: 768px) {
  .take-over {
    display: flex;
  }

  .aha-side-left-bottom {
    @apply hidden;
  }

  .list-group {
    @apply grid items-center content-center justify-center pb-16;
    grid-template-columns: repeat(auto-fit, minmax(160px, 224px));
  }
  .aha-slide-left-top {
    @apply justify-start px-3 pl-0;
  }
  .slide-drag {
    display: none;
  }
  .list-group-item {
    &:first-child {
      @apply pt-2;
    }
  }
}

.context-menu-item.context-menu-duplicate{
  .text-duplicate-slide {
    margin-right: 16px;
  }
  .icon-d-key{
    margin-left: 4px;
  }
}

.btn-cta {
  @apply bg-base-10 rounded;
}
@media (min-width: 1200px) {
  .btn-cta:hover {
    box-shadow: 0 0 0 2px $primary-color;

    svg {
      color: $primary-color;
    }
  }
}
</style>
